export default __webpack_public_path__ + "static/media/waterproofing.4332c16e.jpg";